import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { ConfigService } from 'nr-common';
import { catchError, throwError } from 'rxjs';

/**
 * Interceptor that handles 503 Service Unavailable responses (maintenance mode).
 * Redirects to maintenance page when a 503 error is detected.
 */
export const maintenanceInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
	const config = inject(ConfigService);

	if (config.isMaintenanceActive) {
		return next(req);
	}

	return next(req).pipe(
		catchError((error: HttpErrorResponse) => {
			if (error.status == HttpStatusCode.ServiceUnavailable) {
				window.location.href = config.maintenanceUrl + '?returnUrl=' + encodeURIComponent(window.location.href);
			}
			return throwError(() => error);
		})
	);
};

